/**
 * Environment variables
 */
export const Env = {
  NODE_ENV: process.env.NODE_ENV,
  API_BASE_URL: process.env.REACT_APP_API_BASE_URL,
  WEBSOCKET_URL: process.env.REACT_APP_WEBSOCKET_URL,

  isProd() {
    return this.NODE_ENV === 'production';
  },
  isDev() {
    return this.NODE_ENV === 'development';
  },
  isTest() {
    return this.NODE_ENV === 'test';
  }
};

export default Env;
